import React from 'react';
import './App.css';
import './w3.css';
import '@piggybank/core/lib/styles.css';
import '@piggybank/form/lib/styles.css';
import Controller from './app/Controller';

function App() {
	return (
		<div>
			<Controller />
		</div>
	);
}

export default App;
